import { RemoteSourceAutoComplete } from 'components/RemoteSourceAutoComplete';
import apiEndpoints from 'constants/endpoints';
import React from 'react';
export const CountrySelect = ({ onChange, countryId, disabled = false, placeholder, params = {} }) => {
  return (
    <RemoteSourceAutoComplete
      apiPath={apiEndpoints.countries}
      queryParams={params}
      localFilter={true}
      selectedId={countryId}
      disabled={disabled}
      getOptionLabel={(option => option.name)}
      onChange={onChange}
      placeholder={placeholder || "Country"}
    />
  )
};
